import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function Header() {
	const button = document.getElementById('burger');
	const navAnimEl = document.getElementById('nav-anim');
	const header = document.getElementById('header');
	let matchMedia = gsap.matchMedia();

	matchMedia.add(
		{
			isMobile: '(max-width: 959px)',
			isDesktop: '(min-width: 960px)',
		},
		function (context) {
			const { isMobile, isDesktop } = context.conditions;

			context.add('handleEscape', function (e) {
				if (e.code === 'Escape' && isMobile) {
					hide();
				}
			});

			context.add('handleClick', function (e) {
				const clickFromInside = e.target.closest('#main-nav');
				if (!clickFromInside && isMobile) {
					hide();
				}
			});

			if (isDesktop) {
				gsap.set(navAnimEl, { clearProps: 'all' });
			} else {
				// Check if previously open/closed and restore state
				const isOpen = button.getAttribute('aria-expanded') === 'true';
				isOpen ? show(false) : hide(false);
			}

			// Hide nav when user presses Escape key or clicks outside nav area
			document.addEventListener('keyup', context.handleEscape);
			document.addEventListener('click', context.handleClick);

			return function () {
				// make sure to clean up event listeners in the cleanup function!
				document.removeEventListener('keyup', context.handleEscape);
				document.removeEventListener('click', context.handleClick);
			};
		}
	);

	function hide(animate = true) {
		button.setAttribute('aria-expanded', false);
		const tl = gsap.timeline();
		tl.to(navAnimEl, {
			height: 0,
			duration: animate ? 0.1 : 0,
			ease: 'none',
			autoAlpha: 0,
		});
	}

	function show(animate = true) {
		button.setAttribute('aria-expanded', true);
		const tl = gsap.timeline();
		tl.set(navAnimEl, {
			top() {
				return header.offsetHeight;
			},
		});
		tl.fromTo(
			navAnimEl,
			{
				autoAlpha: 0,
				height: 0,
			},
			{
				autoAlpha: 1,
				height: 'auto',
				duration: animate ? 0.2 : 0,
			}
		);
	}

	const hideTime = 0.1;
	const buttonSelector = '.js-dropdown-button';
	const activeButtonSelector = `${buttonSelector}[aria-expanded="true"]`;

	function checkActive() {
		const active = document.querySelector(activeButtonSelector);
		if (active) {
			showMenu(active, false);
		}
	}

	// This basically helps keep the nav in sync when switching between mobile and desktop styles
	// https://gsap.com/docs/v3/HelperFunctions/helpers/callAfterResize
	function callAfterResize(func, delay) {
		let dc = gsap.delayedCall(delay || 0.2, func).pause();
		let handler = () => dc.restart(true);
		window.addEventListener('resize', handler);
		return handler; // in case you want to window.removeEventListener() later
	}

	function handleEscape(e) {
		if (e.code === 'Escape') {
			hideMenu();
		}
	}

	function hideMenu(el) {
		const button = el || document.querySelector(activeButtonSelector);
		if (!button) return;
		const menu = button.nextElementSibling;
		button.setAttribute('aria-expanded', 'false');
		gsap.to(menu, {
			height: 0,
			duration: hideTime,
			ease: 'none',
			autoAlpha: 0,
		});
	}

	function focusSearch() {
		document.body.classList.add('search-is-active');
		const headerSearchForm = document.getElementById('search-header-search');
		if (headerSearchForm) {
			const searchInput = headerSearchForm.querySelector('input');
			searchInput.focus();
		}
	}

	function showMenu(el, animate = true) {
		const button = el;
		const active = document.querySelector(activeButtonSelector);
		if (button !== active) {
			hideMenu(active);
		}
		button.setAttribute('aria-expanded', 'true');
		const menu = button.nextElementSibling;
		const tl = gsap.timeline({ delay: active ? hideTime : 0 });
		tl.set(menu, {
			height: 'auto',
			autoAlpha: 1,
		}).from(menu, {
			height: 0,
			duration: animate ? 0.2 : 0,
			ease: 'power2.out',
			immediateRender: false,
			autoAlpha: 0,
			onComplete() {
				if (menu.id === 'menu-search') {
					focusSearch();
				}
			},
		});
	}

	function handleClick(e) {
		const button = e.target.closest(buttonSelector);
		const clickFromInsideHeader = e.target.closest('#header');

		if (button) {
			const isActive = button.getAttribute('aria-expanded') === 'true';
			isActive ? hideMenu(button) : showMenu(button);
		} else if (!clickFromInsideHeader) {
			hideMenu();
		}
	}

	// Header search dropdown functionality already handled by dropdown.js module
	const searchCloseButton = document.getElementById('search-close-button');
	const searchPageForm = document.getElementById('search-page-search');

	// Search close button will always exist because it's in the header on every page
	searchCloseButton.addEventListener('click', function () {
		hideMenu();
	});

	// Check if separate in-page form is present.
	// If so, use the filters handler function to run the ajax filtering
	if (searchPageForm) {
		searchPageForm.addEventListener('submit', function (e) {
			// filters.handle(e);
			log('filters.handle(e);');
		});
	}

	// Toggle aria-expanded attribute
	button.addEventListener('click', function () {
		const isOpen = button.getAttribute('aria-expanded') === 'true';
		isOpen ? hide() : show();
	});

	ScrollTrigger.create({
		trigger: document.body,
		start: 'top+=1px top',
		onToggle: self =>
			self.isActive
				? document.body.classList.add('user-has-scrolled')
				: document.body.classList.remove('user-has-scrolled'),
	});

	document.addEventListener('click', handleClick);
	document.addEventListener('keyup', handleEscape);
	callAfterResize(checkActive);

	hideMenu();
}

export default Header;
